import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GoogleAuthProvider } from 'firebase/auth';
import { firebaseAuth } from '@/firebase';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UntypedFormGroup } from '@angular/forms';
import { loginDetails, LoginResponse } from '@/modals/loginDetails';
import { ConfigService } from './config.service';
import { EventBookingDetails } from '@/modals/event-details/eventBookingDetails';
import { WorkshopRegistrationDetails } from '@/modals/workshop-details/workshopRegistrationDetails';
import { LocalDataServiceService } from './local-data-service.service';
import { Volunteer } from '@/modals/volunteer';

const provider = new GoogleAuthProvider();

@Injectable({
  providedIn: 'root'
})
export class AppService {
  public user: any = null;

  constructor(private router: Router, private toastr: ToastrService,
    private http: HttpClient, private configService: ConfigService,
    private localData: LocalDataServiceService) { }

  async getProfile() {
    try {
      this.user = localStorage.getItem('authToken')
    } catch (error) {
      this.logout();
      throw error;
    }
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('gatekeeper_token');
    this.user = null;
    localStorage.clear();
    this.router.navigate(['/login']);
  }


  //Send the Phone Number OTP
  sendPhoneNumberOTP(userForm: UntypedFormGroup) {
    return this.http.post<loginDetails>(
      this.configService.getConfig().END_POINT + "/auth/phoneNumber/send-otp", userForm
    )
  }

  // Send the email OTP for login
  sendEmailOTPForLogin(userForm: UntypedFormGroup) {
    return this.http.post(
      this.configService.getConfig().END_POINT + "/auth/login/email/send-otp", userForm)
  }

  // Check the Temporary Phone Number OTP Verification
  regPhoneNumberVerifyOtp(userForm: any) {
    return this.http.post<loginDetails>(
      this.configService.getConfig().END_POINT + "/auth/phoneNumber/verify-otp-temp", userForm
    )
  }

  // Check the email OTP Verification For Login
  emailVerifyOtpForLogin(emailOtp: any) {
    return this.http.post<LoginResponse>(
      this.configService.getConfig().END_POINT + "/auth/login/email/verify-otp", emailOtp
    )
  }

  // Send the email OTP Verification
  sendEmailOTP(userForm: UntypedFormGroup) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/auth/email/send-otp", userForm)
  }

  // Check the email OTP Verification
  emailVerifyOtp(emailBody: any) {
    return this.http.post(
      this.configService.getConfig().END_POINT + "/auth/email/verify-otp", emailBody
    )
  }

  //Event details save
  saveEventDetails(userForm: UntypedFormGroup) {
    return this.http.post<EventBookingDetails>(
      this.configService.getConfig().END_POINT + "/api/event/register", userForm,
      { headers: this.localData.getHeaders() }
    )
  }

  //Update E=event details save
  updateEventDetails(userForm: UntypedFormGroup) {
    return this.http.post<EventBookingDetails>(
      this.configService.getConfig().END_POINT + "/api/event/update", userForm,
      { headers: this.localData.getHeaders() }
    )
  }

  //Event details get all
  eventDetailsGetAll() {
    return this.http.get<any[]>(
      this.configService.getConfig().END_POINT + "/api/event/get-all",
    )
  }

  //Get all workshop details
  getAllWorkshopDetails() {
    return this.http.get<WorkshopRegistrationDetails[]>(
      this.configService.getConfig().END_POINT + "/api/workshop/getAll",
      { headers: this.localData.getHeaders() }
    )
  }

  //Admin login 
  adminLogin(userForm: UntypedFormGroup) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/auth/login", userForm)
  }

  //Event details get by id
  eventDetailsGetById(eventId: number) {
    return this.http.get<EventBookingDetails>(
      this.configService.getConfig().END_POINT + "/api/event/get/" + eventId,
    )
  }

  //Event details get by id
  getEventIdWorkshopDetails(event_id: number) {
    return this.http.get<any>(
      this.configService.getConfig().END_POINT + "/api/workshop/getAllByEvent/" + event_id,
    )
  }


  saveEventRegisteredDetails(formData: any) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/auth/workshop/register", formData,
    )

  }


  getByEventId(eventId: number) {
    return this.http.get<EventBookingDetails>(
      this.configService.getConfig().END_POINT + `/api/event/get/${eventId}`,
    )
  }

  getTicketById(ticketNo: string) {
    return this.http.get<any>(
      this.configService.getConfig().END_POINT + `/api/getTicket/${ticketNo}`,
    )

  }

  //city based event details get
  getCityBasedEventDetails(city: string) {
    return this.http.get<EventBookingDetails>(
      this.configService.getConfig().END_POINT + `/api/event/getByCity/${city}`
    )
  }


  saveVolunteerDetail(formData: any) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/auth/volunteer/register", formData,
    )

  }

  //get all volunteer details
  getAllVolunteers() {
    return this.http.get<Volunteer[]>(
      this.configService.getConfig().END_POINT + "/api/volunteer/getAll",
      { headers: this.localData.getHeaders() }
    )
  }

  //event get by id volunteer details
  volunteerDetailsGetByEventId(eventId: number) {
    return this.http.get<Volunteer[]>(
      this.configService.getConfig().END_POINT + `/api/volunteer/getByEventId/${eventId}`,
      { headers: this.localData.getHeaders() }
    )
  }

  //Duplicate phone and email check
  duplicatePhoneandEmailCheck(formData: any) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/auth/workshop/check-duplicate", formData,
    )
  }

  //Reminder mail send
  sendReminderEmails(workshopId: number) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/auth/workshop/send-reminder/" + workshopId,
      { headers: this.localData.getHeaders() }
    )
  }

  //Reminder whatsapp send
  sendReminderWhatsapp(workshopId: number) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/auth/phoneNumber/send-reminder/" + workshopId,
      { headers: this.localData.getHeaders() }
    )
  }

  //Search Participants Details
  searchParticipants(formData: any) {
    return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/api/getTicketByWhatsapp", formData,
    )
  }

  //send reminder bulk whatsapp 
  sendReminderBulkWhatsapp(jsonData : any){
     return this.http.post<any>(
      this.configService.getConfig().END_POINT + "/auth/phoneNumber/send-reminder-bulk", jsonData,
    )
  }

  //Feeddback details get by event id
  getEventIdFeedback(event_id: number) {
    return this.http.get<any>(
      this.configService.getConfig().END_POINT + "/api/feedback/event/" + event_id,
    )
  }

  //save feedback
  saveFeedbacks(formData: any) {
    return this.http.post(
      this.configService.getConfig().END_POINT + "/auth/feedback/save", formData,
    )
  }

}
